import { Check } from 'lucide-react';
import { TRADE_BENEFITS, TRADE_SUITED } from '../mock';

export default function TradeIndustrial() {
  return (
    <section id="trade" className="bg-[#e9e3d6] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="eyebrow">Trade Counter &amp; Industrial</span>
          <h2 className="font-serif-display text-[42px] md:text-[54px] leading-[1.05] mt-6">
            Visibility.  Accessibility.<br />
            <em className="text-[#b39352] italic">Practical space.</em>
          </h2>
          <p className="mt-6 text-[14px] leading-[1.85] text-[#0d281e]/80 max-w-xl">
            Purpose-designed accommodation for trade businesses that need street presence, easy loading
            access and a practical, high-spec workspace.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <span className="eyebrow">Benefits Include</span>
            <ul className="mt-8 space-y-4">
              {TRADE_BENEFITS.map((b) => (
                <li key={b} className="flex items-center gap-4 text-[14px] text-[#0d281e]">
                  <Check size={16} className="text-[#b39352]" strokeWidth={2.5} />
                  {b}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <span className="eyebrow">Ideally suited for</span>
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-x-8">
              {TRADE_SUITED.map((s, i) => (
                <div key={s} className="num-list-item">
                  <span className="num">{String(i + 1).padStart(2, '0')}</span>
                  <span className="text-[14px]">{s}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
